/*
 * Authentication Reducer
 */
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  GET_CURRENT_PRINCIPAL,
  GET_CURRENT_PRINCIPAL_SUCCESS,
  GET_CURRENT_PRINCIPAL_ERROR,
  REMEMBER_ME,
  FORGET_ME,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  GET_USER_ROLES,
  GET_USER_ROLES_SUCCESS,
  GET_USER_ROLES_ERROR,
} from './../actions/Authentication';
import { CLEAR_ACTION_RESPONSE } from './../actions/Global';
import { Record, List, fromJS } from 'immutable';
import { setInStorage, clearStorage } from './../persistence/storage';
import { setInSession, clearSession } from './../persistence/session';
import { convertAxiosSuccess, convertAxiosError } from './../utility/ConverterUtils';

/* The initial state of the App */
const AuthenticationStateRecord = Record({
  isLoading: false,
  userRoles: List(),
  actionResponse: null,
  token: null,
  user: null,
});

const authentication = (state = new AuthenticationStateRecord({}), action) => {
  switch (action.type) {
    case LOGIN:
      return login(state);
    case LOGIN_SUCCESS:
      return loginSuccess(state, action);
    case LOGIN_ERROR:
      return loginError(state, action);

    case LOGOUT:
      return logout(state);
    case LOGOUT_SUCCESS:
      return logoutSuccess(state);
    case LOGOUT_ERROR:
      return logoutError(state);

    case GET_CURRENT_PRINCIPAL:
      return getCurrentPrincipal(state);
    case GET_CURRENT_PRINCIPAL_SUCCESS:
      return getCurrentPrincipalSuccess(state, action);
    case GET_CURRENT_PRINCIPAL_ERROR:
      return getCurrentPrincipalError(state, action);

    case GET_USER_ROLES:
      return getUserRolesAll(state);
    case GET_USER_ROLES_SUCCESS:
      return getUserRolesAllSuccess(state, action);
    case GET_USER_ROLES_ERROR:
      return getUserRolesAllError(state, action);

    case REMEMBER_ME:
      return rememberMe(state, action);
    case FORGET_ME:
      return forgetMe(state);

    case CLEAR_ACTION_RESPONSE:
      return clearActionResponse(state);

    default:
      return state;
  }
};

/** The state of the App on LOGIN action */
const login = (state) => {
  return state.setIn(['isLoading'], true);
};

/** The state of the App on LOGIN_SUCCESS action */
const loginSuccess = (state, action) => {
  setInSession('dfim-jwt-access-token', action.payload.result.token.accessToken);
  setInSession('dfim-jwt-expires', new Date(action.payload.result.token.expires));

  return state
    .setIn(['isLoading'], false)
    .setIn(['token'], action.payload.result.token.accessToken)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

/** The state of the App on LOGIN_ERROR action */
const loginError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

/** The state of the App on LOGOUT action */
const logout = (state) => {
  return state.setIn(['isLoading'], true);
};

/** The state of the App on LOGOUT_SUCCESS action */
const logoutSuccess = (state) => {
  return state.setIn(['isLoading'], false).setIn(['user'], null).setIn(['token'], null);
};

/** The state of the App on LOGOUT_ERROR action */
const logoutError = (state) => {
  return state.setIn(['isLoading'], false);
};

/** The state of the App on GET_CURRENT_PRINCIPAL action */
const getCurrentPrincipal = (state) => {
  return state.setIn(['isLoading'], true).setIn(['user'], null);
};

/** The state of the App on GET_CURRENT_PRINCIPAL_SUCCESS action */
const getCurrentPrincipalSuccess = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['user'], fromJS(action.payload.result.user))
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

/** The state of the App on GET_CURRENT_PRINCIPAL_ERROR action */
const getCurrentPrincipalError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const getUserRolesAll = (state) => {
  return state.setIn(['userRoles'], state.userRoles.clear()).setIn(['isLoading'], false);
};

const getUserRolesAllSuccess = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['userRoles'], fromJS(action.payload.result.roles))
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const getUserRolesAllError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

/** The state of the App on REMEMBER action */
const rememberMe = (state, action) => {
  if (action.payload.result.rememberMe) {
    setInStorage('dfim-jwt-access-token', action.payload.result.token.accessToken);
    setInStorage('dfim-jwt-expires', new Date(action.payload.result.token.expires));
  }

  return state;
};
/** The state of the App on FORGET_ME action */
const forgetMe = (state) => {
  clearSession();
  clearStorage();

  return state;
};

/** Clears the reducer errors */
const clearActionResponse = (state) => {
  return state.setIn(['actionResponse'], null);
};

export default authentication;
